export function buildSingleDisplayName(category: $TSFixMe) {
  if (category) {
    let displayName = category.name || "";

    if (category.parent?.name) {
      displayName = `${buildSingleDisplayName(category.parent)} - ${category.name}`;
    }
    return displayName;
  }
  return "";
}

export function extractProductCategoryItem(rawProductCategory: $TSFixMe) {
  if (rawProductCategory) {
    const displayName = buildSingleDisplayName(rawProductCategory);

    if (rawProductCategory.id) {
      return {
        id: rawProductCategory.id,
        name: displayName,
      };
    }
    return {};
  }
  return {};
}
